import { Controller } from "@hotwired/stimulus";

// Counts label-to-label traversal, the loop the Dig program is built on
// (docs/designs/dig-walk.md). Delegated from the list so both links on a card
// report the same way.
export default class extends Controller {
  static values = { source: String, surface: String };

  report(event) {
    // Only clicks that navigate count: a chip or a stray tap inside the card is
    // not a click-through, and counting it inflates the gate this stage feeds.
    const link = event.target.closest("a[href], wa-button[href]");
    const card = link?.closest("[data-similar-click-label]");
    if (!card) return;

    // Analytics is blocked for a large share of visitors, and a throwing
    // reporter must never cost them the navigation.
    try {
      window.plausible?.("Similar Label Click", {
        props: {
          source: this.sourceValue,
          target: card.dataset.similarClickLabel,
          position: Number(card.dataset.similarClickPosition),
          surface: this.surfaceValue,
        },
      });
    } catch {}
  }
}
